export const environment = {
  production: false,
  version: '0.0.0-development',
  THEWALL_URL: 'https://thewall-preview.slidebean.com/graphql',
};
